<!--
 * @Author: xiexp
 * @Description: 
 * @Date: 2022-08-23 15:52:45
 * @LastEditTime: 2022-08-27 13:10:29
 * @FilePath: \indiba-web-new\src\pages\mobile\Section2.vue
-->
<template>
  <div class="section2">
    <nav-menu @click="$emit('open')"></nav-menu>
    <ul class="section2__main">
      <li>
        <div class="icon-wrapper">
          <i class="ri-pulse-fill"></i>
        </div>
        独有的448kHz频率
      </li>
      <li>
        <div class="icon-wrapper">
          <i class="ri-draft-line"></i>
        </div>
        超过39年的经验
      </li>
      <li>
        <div class="icon-wrapper">
          <i class="ri-earth-line"></i>
        </div>
        +25000台设备遍布全球
      </li>
      <li>
        <div class="icon-wrapper">
          <i class="ri-file-mark-line"></i>
        </div>
        <div></div>
      </li>
      <li>
        <div class="icon-wrapper">
          <i class="ri-microscope-line"></i>
        </div>
        超过500+实例研究文献
      </li>
      <li>
        <div class="icon-wrapper">
          <i class="ri-shield-check-line"></i>
        </div>
        安全性&有效性经过多方测试和证明
      </li>
      <li>
        <div class="icon-wrapper">
          <i class="ri-medal-line"></i>
        </div>
        产品通过多国专业认证
      </li>
    </ul>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
export default {
  components: {
    NavMenu,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.section2 {
  position: relative;
  height: 100%;
  background: url(../../assets/home/page2_bg.png);
  background-size: cover;
  color: #fff;
  .section2__main {
    padding-top: 5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    li {
      height: 3.5rem;
      margin-bottom: 2rem;
      font-size: 1rem;
      display: flex;
      align-items: center;
    }
  }

  .icon-wrapper {
    width: 3.5rem;
    height: 3.5rem;
    margin-right: 1rem;
    background: rgba(54, 90, 189);
    border-radius: 50%;
    opacity: 0.65;
    font-size: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
